import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CustomerPointsRowModel } from '../../../../models/customer-points-row.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { SearchToolbarComponent } from '../../../../modules/UIKit/components/searchToolBar/search-toolbar.component';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';

@Component({
  selector: 'app-customer-points-redemption',
  templateUrl: './customer-points-redemption.component.html',
  styleUrls: ['./customer-points-redemption.component.css']
})
export class CustomerPointsRedemptionComponent implements OnInit {
  @ViewChild('toolbar') toolbarRef: SearchToolbarComponent;

  public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();

  translations: any;

  leftChart: LoyaltyChart;

  public indicators: IndicatorBoxModel[] = [];
  public data: QFilterModel;
  public datatable: Array<CustomerPointsRowModel> = [];
  public sumRow: CustomerPointsRowModel;


  @Input() selectedElapsedStart: Date  = null;
  @Input() selectedElapsedEnd: Date = null;

  public get filterApplied(): boolean {
    return this.data != null;
  }

  public resetData(){
    this.indicators = [];
    this.data = null;
    this.datatable = [];
    this.initSumRow();
  }

  constructor(
    private indicatorService: IndicatorsService,
    private chartsService: IndicatorsChartService,
    private svcAnalytics: AnalyticsService,
    private srvCustomerCampaign: CustomerCampaignService,
    private translate: TranslateService,
    private searchModelFactory: SearchToolbarModelFactoryService,
  ) { }

  initCharts() {
    this.leftChart = (new LoyaltyChart('area'));
    this.leftChart.options.plotOptions = { area: { stacking: 'normal' } };

    this.leftChart.options.xAxis.title.text = this.translations.chart_x_title;
    this.leftChart.options.yAxis.title.text = this.translations.chart_y_title;
  }

  ngOnInit() {
    this.translate.get([
      'customer_chart.points_redemption_title',
      'loyalty_chart.penetrazioneCarta',
      'customer_chart.delta',
      'customer_chart.erogation',
      'customer_chart.points',
      'customer_chart.current',
      'customer_chart.previous',
      'customer_chart.mechanics',
      'customer_chart.totals',
      'loyalty_chart.period'
    ]).subscribe((t) => {
      this.translations = {
        penetrazioneCarta: t['loyalty_chart.penetrazioneCarta'],
        chart_title: t['customer_chart.points_redemption_title'],
        chart_delta: t['customer_chart.delta'],
        chart_erogation: t['customer_chart.erogation'],
        chart_points: t['customer_chart.points'],
        chart_current: t['customer_chart.current'],
        chart_previous: t['customer_chart.previous'],
        chart_mechanics: t['customer_chart.mechanics'],
        chart_totals: t['customer_chart.totals'],
        chart_x_title: t['loyalty_chart.period'],
        chart_y_title: t['customer_chart.points']
      };
    });

    this.initCharts();
    this.initSumRow();
  }

  initSumRow() {
    this.sumRow = {
      meccanica: 'customer_chart.totals',
      pt_corr: 0,
      pt_prec: 0,
      pt_delta: 0,
      erog_corr: 0,
      erog_prec: 0,
      erog_delta: 0
    };
  }

  setChartInstance(chart: LoyaltyChart, chartInstance) {
    chart.instance = chartInstance;
  }

  searchValueTrend(data: QFilterModel) {
    this.data = data;

    this.translate.get([
      'indicator.valore_punti_erogati',
      'indicator.valore_punti_redenti',
      'indicator.perc_redenzione',
      'indicator.fondo_accantonamento',
    ]).subscribe(indicatorTranslations => {
      this.indicators = [];
      this.datatable = [];
      this.initSumRow();

      this.indicatorService.indicatorCalculation('Q029', this.data).switchMap((res) => {
        const erogati = [
          res.find(ind => ind.name === 'valore_punti_erogati')
        ];

        const redenti = [
          res.find(ind => ind.name === 'valore_punti_redenti')
        ];

        const redenzione = [
          res.find(ind => ind.name === 'perc_redenzione')
        ];

        this.indicators.push(new IndicatorBoxModel(erogati, {dynamic: true, unit_period_prec: '€'}, indicatorTranslations));
        this.indicators.push(new IndicatorBoxModel(redenti, {dynamic: true, unit_period_prec: '€'}, indicatorTranslations));
        this.indicators.push(new IndicatorBoxModel(redenzione, {unit_period_prec: '%'}, indicatorTranslations));

        return this.indicatorService.indicatorCalculation('Q032', this.data);
      }).subscribe((res) => {
        this.indicators.push(new IndicatorBoxModel([res.find(ind => ind.name === 'fondo_accantonamento')], {dynamic: true, unit_period_prec: '€'}, indicatorTranslations));
      });
    });

    console.log("CHART ::: ", this.leftChart.instance);

    this.chartsService.loadChart(this.leftChart, 'Q053', data, this.indicatorService, null, true);

    this.indicatorService.getCustomersPointsTable('Q054', this.data, 'descrizione_redenzione').subscribe((resp) => {
      if (resp.length >= 2) {
        this.datatable = resp.slice(0, resp.length - 1);
        this.sumRow = resp[resp.length - 1];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers-points/customer-points-redemption/customer-points-redemption.component.ts